module.exports = __webpack_public_path__ + "img/wx-qcode.ac487512.png";